import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withStyles } from '@material-ui/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Icon from '@material-ui/core/Icon';
import { uiState } from 'react-redux-ui-state';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import Cached from '@material-ui/icons/Cached';
import Fab from '@material-ui/core/Fab';
import BusyButton from '../../../BusyButton/BusyButton';

const propTypes = {
  // eslint-disable-next-line react/require-default-props
  className: PropTypes.string,
  classes: PropTypes.shape({}).isRequired,
  deleteUserInviteState: PropTypes.func.isRequired,
  resendUserInviteState: PropTypes.func.isRequired,
  invite: PropTypes.shape({
    id: PropTypes.string.isRequired,
    email2invite: PropTypes.string.isRequired,
    role: PropTypes.string.isRequired,
    isExpired: PropTypes.bool.isRequired,
    swappedtoken: PropTypes.bool.isRequired,
  }).isRequired,
};

// eslint-disable-next-line no-unused-vars
const defaultProps = {
  className: null,
};

export function UnstyledInviteUserCard({
  classes,
  className,
  invite,
  deleteUserInviteState,
  resendUserInviteState,
}) {
  function handleDeleteClick() {
    deleteUserInviteState(invite.id);
  }

  function handleResendClick() {
    const data = {
      email2invite: invite.email2invite,
      role: invite.role,
    };
    resendUserInviteState(invite.id, data);
  }

  function inviteColor(obj) {
    if (obj.isExpired) {
      return '#FF0000';
    }
    return '#E8AA42';
  }

  let tempRole = invite.role;
  if (tempRole === 'readonly user') {
    tempRole = 'Read Only';
  }

  return (
    <Card className={classnames(className, classes.cardContainer)}>
      <CardHeader
        avatar={
          <Icon
            style={{
              color: inviteColor(invite),
            }}
            className={classes.icon}
          >
            account_circle
          </Icon>
        }
        title={invite.email2invite}
        subheader={tempRole}
        className={classes.addUserHeader}
        classes={{
          action: classes.action,
          subheader: classes.capitalize,
          title: classes.title,
          content: classes.content,
        }}
      />
      <CardContent>
        <div>
          <TextField
            variant="outlined"
            name="email2invite"
            label="Email"
            placeholder="Email"
            fullWidth
            margin="normal"
            defaultValue={invite.email2invite}
            disabled
          />
          <TextField
            variant="outlined"
            fullWidth
            name="role"
            label="Role"
            placeholder="Select a Role"
            defaultValue={invite.role}
            margin="normal"
            disabled
            autoCapitalize="none"
            InputProps={{
              classes: {
                input: classes.capitalize,
              },
            }}
          />
          {invite.isExpired ? (
            <div className={classes.redVerbiage}>EXPIRED</div>
          ) : (
            <div className={classes.pendingVerbiage}>Pending Sign-up</div>
          )}
        </div>
      </CardContent>
      <div className={classes.buttonContainer}>
        <Fab size="small" classes={{ root: classes.cancelButton }} onClick={handleDeleteClick}>
          <Tooltip title="Delete invite">
            <Icon>delete</Icon>
          </Tooltip>
        </Fab>
        <BusyButton
          // disabled={!valid || pristine}
          name="submit"
          type="submit"
          variant="fab"
          color="primary"
          size="small"
          className={classes.resendButton}
          onClick={handleResendClick}
        >
          <Tooltip title="Resend invite">
            <Cached fontSize="large" />
          </Tooltip>
        </BusyButton>
      </div>
    </Card>
  );
}

UnstyledInviteUserCard.propTypes = propTypes;

const styles = (theme) => ({
  addUserHeader: {
    display: 'flex',
  },
  cardContainer: {
    marginTop: theme.spacing(1),
    paddingBottom: '0px',
  },
  action: {
    alignSelf: 'center',
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
    },
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  capitalize: {
    textTransform: 'capitalize',
  },
  redVerbiage: {
    color: 'red',
    paddingLeft: theme.spacing(1.5),
  },
  pendingVerbiage: {
    color: theme.customColors.mediumGrey,
    paddingLeft: theme.spacing(1.5),
  },
  buttonContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    lineHeight: '0.5em',
  },
  resendButton: {
    cursor: 'pointer',
    margin: theme.spacing(2),
  },
  cancelButton: {
    cursor: 'pointer',
    margin: theme.spacing(2),
    color: theme.customColors.white,
    backgroundColor: theme.customColors.red,
  },
  icon: {
    fontSize: 50,
    [theme.breakpoints.down('sm')]: {
      fontSize: 35,
    },
  },
  title: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
    },
  },
  content: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
});

export const uiConfig = {
  name: 'InviteUserCard',
  state: () => ({
    userInviteCardOpen: false,
  }),
};

export default uiState(uiConfig)(withStyles(styles)(UnstyledInviteUserCard));
